module.exports = __webpack_public_path__ + "img/card_1.c974ae47.svg";